export const api_url = process.env.REACT_APP_SERVICE_API
export const main_url = process.env.REACT_APP_MAIN_URL